import './MyContracts.scss';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Label, Form, Button } from 'reactstrap';
import SearchInput from '../../commons/SearchInput';
import Header from '../../commons/Header';
import Footer from '../../commons/Footer';
import BurgerMenu from '../../commons/BurgerMenu';
import { ReactComponent as IconBuilding } from '../../images/icn_buildings.svg';
import {
  ContFilterYear,
  ContFlexLeft,
  ContFlexRight,
  ContPaginationPage,
} from '../../styled-components';
import FormGroup from 'reactstrap/lib/FormGroup';
import CustomInput from 'reactstrap/lib/CustomInput';
import generatePaginationOptions from '../../lib/helpers/generatePaginationOptions';
import ContractsTable from './ContractsTable';
import { useAlert } from 'react-alert';
import ContractsImportFeedbackModal from './ContractsImportFeedbackModal';
import ExportCSVButton from './ExportCSVButton';
import { ADMIN_TYPES } from '../../App';
import generateYearOptions from '../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../lib/helpers/generateMonthOptions';
import IafPolisImportFeedbackModal from './IafPolisImportFeedbackModal';

const ContractsPresentational = ({
  data,
  formattedData,
  profile,
  profileScore,
  query,
  total,
  onFilter,
  onCondoUpdate,
  onChangeAdmin,
  onExtendAdminManagement,
  checkVatCode,
  onImportContract,
  contractsImportFeedbackData,
  hasImportedContracts,
  toggleShowImportFeedback,
  totPod = 0,
  totPdr = 0,
  onImportIafPolis,
  toggleShowImportIafPolisFeedback,
  iafPolisImportFeedbackData,
  hasImportedIafPolis,
  onStatusChanged,
  handleFileListView,
  handleDelete,
}) => {
  const [t] = useTranslation('CONTRACTS');
  const {
    offset,
    limit,
    customerType,
    managementStatus,
    contractType,
    partnerEonType,
  } = query;
  const alert = useAlert();

  function handleImportFile(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportContract(data);
    }
  }

  function handleImportIafPolis(event) {
    const file = event.target?.files[0];
    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      window.alert('File troppo grande. Sono ammessi file di massimo 20MB');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    onImportIafPolis(formData);
  }

  return (
    <div className="App">
      <BurgerMenu />

      <div className="corpo">
        <ContractsImportFeedbackModal
          data={contractsImportFeedbackData}
          toggle={toggleShowImportFeedback}
          isOpen={hasImportedContracts}
        />

        <IafPolisImportFeedbackModal
          data={iafPolisImportFeedbackData}
          toggle={toggleShowImportIafPolisFeedback}
          isOpen={hasImportedIafPolis}
        />

        <section>
          <Header
            title={t('PAGES:CONTRACTS')}
            icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
          />

          <Row className="align-items-center">
            {ADMIN_TYPES.includes(profile.type) && (
              <Col className="">
                <ContFlexLeft>
                  {t('SCORE:CONTRACTS_SCORE')}:&nbsp;
                  <strong>{profileScore.EONScore || 0}</strong>
                </ContFlexLeft>
              </Col>
            )}
            <Col className="">
              <ContFlexRight>
                Contratti POD:&nbsp;<strong>{totPod}</strong>&nbsp; | Contratti
                PDR:&nbsp;<strong>{totPdr}</strong>
              </ContFlexRight>
            </Col>
          </Row>

          {profile.type === 'EON_ENERGY' && profile.polis !== true && (
            <Row>
              <Col sm="12" md="12" lg="4" xl="4">
                <Button
                  href={`/examples/Template_Contratti.csv`}
                  target="_blank"
                  color="primary"
                  style={{ width: '100%' }}
                >
                  Scarica template importazione
                </Button>
              </Col>
              <Col sm="12" md="12" lg="4" xl="4">
                <Button
                  href={`/documentation/Extra_Importazione_contratti.pdf`}
                  target="_blank"
                  color="primary"
                  style={{ width: '100%' }}
                >
                  Scarica documentazione importazione
                </Button>
              </Col>

              <Col sm="0" md="0" lg="1" xl="1"></Col>

              <Col sm="12" md="12" lg="3" xl="3">
                <ExportCSVButton data={formattedData} />
              </Col>
            </Row>
          )}

          {profile.type === 'EON_ENERGY' && profile.polis === true && (
            <Row>
              <Col sm="12" md="12" lg="4" xl="4">
                <Button
                  href={`/documentation/Extra_Importazione_contratti_Polis.pdf`}
                  target="_blank"
                  color="primary"
                  style={{ width: '100%' }}
                >
                  Scarica documentazione importazione
                </Button>
              </Col>

              <Col sm="0" md="0" lg="5" xl="5"></Col>

              <Col sm="12" md="12" lg="3" xl="3">
                <ExportCSVButton data={formattedData} />
              </Col>
            </Row>
          )}

          <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
            {!(profile && profile._id) && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.admin }}
                  onFilter={({ search }) => onFilter({ admin: search })}
                  label={t('SEARCH:ADMINISTRATOR')}
                />
              </Col>
            )}
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.customer }}
                onFilter={({ search }) => onFilter({ customer: search })}
                label={t('SEARCH:CUSTOMER')}
              />
            </Col>
            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.pod_pdr }}
                onFilter={({ search }) => onFilter({ pod_pdr: search })}
                label={t('SEARCH:POD_PDR')}
              />
            </Col>

            <Col sm="6" md="6" lg="3" xl="3">
              <SearchInput
                query={{ search: query && query.condo_vat_cf }}
                onFilter={({ search }) => onFilter({ condo_vat_cf: search })}
                label={t('SEARCH:CLIENT_VAT_CODE')}
              />
            </Col>

            {['EON_ENERGY'].includes(profile.type) && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.condo_admin_cf }}
                  onFilter={({ search }) =>
                    onFilter({ condo_admin_cf: search })
                  }
                  label={t('SEARCH:ADMIN_VAT_CODE')}
                />
              </Col>
            )}

            {!['EON_ENERGY'].includes(profile.type) && (
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.supplier }}
                  onFilter={({ search }) => onFilter({ supplier: search })}
                  label={t('SEARCH:BY_SUPPLIER')}
                />
              </Col>
            )}

            {profile.type !== 'UTILIZER' && (
              <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Tipologia cliente</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="customerType"
                          name="customerType"
                          value={customerType}
                          onChange={({ target: { value: customerType } }) =>
                            onFilter({ customerType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="condos">Condomini</option>
                          <option value="customerExtra">Clienti privati</option>
                          <option value="utilizers">Utilizzatori</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            )}

            {profile.type === 'EON_ENERGY' && (
              <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear className="no-width">
                  <Row>
                    <Col xs="6">
                      <Label>Stato Gestione</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="managementStatus"
                          name="managementStatus"
                          value={managementStatus}
                          onChange={({ target: { value: managementStatus } }) =>
                            onFilter({ managementStatus })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="active">ATTIVO</option>
                          <option value="terminated">TERMINATO</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            )}

            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Tipo fornitura</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractType"
                        name="contractType"
                        value={contractType}
                        onChange={({ target: { value: contractType } }) =>
                          onFilter({ contractType })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="POD">POD</option>
                        <option value="PDR">PDR</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="6" lg="3" xl="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>Voce</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="partnerEonType"
                        name="partnerEonType"
                        value={partnerEonType}
                        onChange={({ target: { value: partnerEonType } }) =>
                          onFilter({ partnerEonType })
                        }
                      >
                        <option value="">Tutti</option>
                        <option value="GETTONE">Gettone</option>
                        <option value="STORNO_GETTONE">Storno Gettone</option>
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>
            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_SIGNIN_YEAR')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="selectContractSigningYear"
                        name="contractSigningYear"
                        value={query && query.contractSigningYear}
                        onChange={({
                          target: { value: contractSigningYear },
                        }) => {
                          onFilter({ contractSigningYear });
                        }}
                      >
                        {generateYearOptions(true)}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            <Col sm="12" md="6" lg="3" className="select-wrapper">
              <ContFilterYear
                className="no-width"
                style={{ marginBottom: '0' }}
              >
                <Row>
                  <Col xs="6">
                    <Label>{t('COMMON:TITLE_FILTER_SIGNIN_MONTH')}</Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <CustomInput
                        type="select"
                        id="contractSigningMonth"
                        name="contractSigningMonth"
                        disabled={!query.contractSigningYear}
                        value={query && query.contractSigningMonth}
                        onChange={({
                          target: { value: contractSigningMonth },
                        }) => onFilter({ contractSigningMonth })}
                      >
                        {generateMonthOptions()}
                      </CustomInput>
                    </FormGroup>
                  </Col>
                </Row>
              </ContFilterYear>
            </Col>

            {profile.polis === true && (
              <Col sm="12" md="4" lg="4">
                <ContFilterYear className="no-width select-wrapper">
                  <Row>
                    <Col xs="6">
                      <Label>{t('CONTACTS:IAF_POLIS_FILTER')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectIafPolis"
                          name="iafPolis"
                          value={query.iafPolis || ''}
                          onChange={(e) =>
                            onFilter({ iafPolis: e.target.value })
                          }
                        >
                          <option value="">Tutti</option>
                          <option value="true">SI</option>
                          <option value="false">NO</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>
            )}
          </Row>

          <Row className="search-add-cont m-t-20" style={{ rowGap: '1rem' }}>
            {profile.type === 'EON_ENERGY' && (
              <Col sm="12" md="6" lg="3" xl="3">
                <FormGroup>
                  <CustomInput
                    type="file"
                    id="importFilee"
                    name="importFilee"
                    onChange={(event) => handleImportFile(event)}
                    accept=".csv"
                  />
                  <Label for="selectFile">
                    {t('ENERGY_CONTRACT:CHOOSE_FILE')}
                    &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                </FormGroup>
              </Col>
            )}

            {profile.polis === true && (
              <Col sm="12" md="6" lg="3">
                <FormGroup>
                  <CustomInput
                    type="file"
                    id="importIafPolis"
                    name="importIafPolis"
                    onChange={handleImportIafPolis}
                    accept=".xlsx"
                  />
                  <Label for="importIafPolis">
                    {t('ENERGY_CONTRACT:CHOOSE_FILE_IAF_POLIS')}
                    &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                </FormGroup>
              </Col>
            )}
          </Row>
        </section>

        <section className="m-t-20">
          <ContractsTable
            data={data}
            total={total}
            offset={offset}
            limit={limit}
            onFilter={onFilter}
            onCondoUpdate={onCondoUpdate}
            onChangeAdmin={onChangeAdmin}
            profile={profile}
            onExtendAdminManagement={onExtendAdminManagement}
            truncateTable={profile && profile._id}
            checkVatCode={checkVatCode}
            energyUser={profile.type === 'EON_ENERGY'}
            handleFileListView={handleFileListView}
            handleDelete={handleDelete}
            onStatusChanged={onStatusChanged}
          />

          <ContPaginationPage>
            <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

            <FormGroup>
              <CustomInput
                type="select"
                className="pagination-select"
                id="perPage"
                name="perPage"
                value={limit}
                onChange={({ target: { value: limit } }) => {
                  onFilter({ limit: limit });
                }}
              >
                {generatePaginationOptions()}
              </CustomInput>
            </FormGroup>
          </ContPaginationPage>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default ContractsPresentational;
